import React from "react";
import loadable from "@loadable/component";
import { isMobile } from "analytics/index";
import RestRefreshTermsPage from "pages/RestRefresh";
const Home = loadable(() =>
  import(/* webpackChunkName: "Home" */ "pages/Home")
);
const TravelSafe = loadable(() =>
  import(/* webpackChunkName: "TravelSafe" */ "pages/TravelSafe")
);
const TravelSafeAdani = loadable(() =>
  import(/* webpackChunkName: "TravelSafeAdani" */ "pages/TravelSafe/adani")
);
const TravelSafeAE = loadable(() =>
  import(/* webpackChunkName: "TravelSafeAE" */ "pages/TravelSafe/ae")
);
const TravelSafeSAandFlyin = loadable(() =>
  import(
    /* webpackChunkName: "TravelSafeSAandFlyin" */ "pages/TravelSafe/saAndFlyin"
  )
);
const TravelSafeGonuclei = loadable(() =>
  import(
    /* webpackChunkName: "TravelSafeGonuclei" */ "pages/TravelSafe/gonuclei"
  )
);
const Cfnr = loadable(() =>
  import(/* webpackChunkName: "Cfnr" */ "pages/Cfnr/index")
);
const EzCancelPage = loadable(() =>
  import(/* webpackChunkName: "EzCancelPage" */ "pages/EzCancel")
);
const EzCancelMobilePage = loadable(()=>
  import(/* webpackChunkName: "EzCancelPage" */ "pages/EzCancelMobile")
);
const FlexiflyMobilePage = loadable(()=>
  import(/* webpackChunkName: "EzCancelPage" */ "pages/FlexiflyMobile")
);
const GiftCard = loadable(() =>
  import(/* webpackChunkName: "GiftCard" */ "pages/GiftCard")
);
const Flexifly = loadable(() =>
  import(/* webpackChunkName: "Flexifly" */ "pages/Flexifly")
);
const CleartripForWork = loadable(() =>
  import(/* webpackChunkName: "CleartripForWork" */ "pages/CleartripForWork")
);
const CleartripForWorkMobile = loadable(() =>
  import(
    /* webpackChunkName: "CleartripForWorkMobile" */ "pages/CleartripForWork/mobile/mobile"
  )
);
const Payback = loadable(() =>
  import(/* webpackChunkName: "Payback" */ "pages/Payback")
);
const Wallet = loadable(() =>
  import(/* webpackChunkName: "Wallet" */ "pages/Wallet")
);
const Packages = loadable(() =>
  import(/* webpackChunkName: "Packages" */ "pages/Packages")
);
const SmilesFaq = loadable(() =>
  import(/* webpackChunkName: "smiles" */ "pages/SmilesFaq")
);
const CleartripPackages = loadable(() =>
  import(/* webpackChunkName: "CleartripPackages" */ "pages/Packages/cleartrip-packages")
);
const FlexiflyAe = loadable(() =>
  import(/* webpackChunkName: "FlexiflyAe" */ "pages/Flexifly/AE/index")
);
const FlightOffer = loadable(() =>
  import(/* webpackChunkName: "FlightOffer" */ "pages/FlightOffer")
);
const CoronaHelp = loadable(() =>
  import(/* webpackChunkName: "CoronaHelp" */ "pages/CoronaHelp")
);
const Creditshell = loadable(() =>
  import(/* webpackChunkName: "Creditshell" */ "pages/Creditshell")
);
const Expressway = loadable(() =>
  import(/* webpackChunkName: "Expressway" */ "pages/Expressway")
);
const CoronaHotelHelp = loadable(() =>
  import(/* webpackChunkName: "CoronaHotelHelp" */ "pages/CoronaHotelHelp")
);
const ContactPage = loadable(() =>
  import(/* webpackChunkName: "ContactPage" */ "pages/Contact")
);
const ContactPageME = loadable(() =>
  import(/* webpackChunkName: "ContactPage" */ "pages/ContactME")
);
const Supercoin = loadable(() =>
  import(/* webpackChunkName: "Supercoin" */ "pages/Supercoin")
);
const EzCancelNew = loadable(() =>
  import(/* webpackChunkName: "Supercoin" */ "pages/EzCancelNew")
);
const EzCancelNewAE = loadable(() =>
  import(/* webpackChunkName: "EzCancelNewAE" */ "pages/EzCancelNewAE")
);
const BBDDekstop = loadable(() =>
  import(/* webpackChunkName: "BBDDekstop", webpackPreload: true */  "pages/BBDDesktop")
);
const TermsOfService = loadable(() =>
  import(/* webpackChunkName: "TermsOfService" */ "pages/TermsOfService")
);
const Grievance = loadable(() =>
  import(/* webpackChunkName: "Grievance" */ "pages/Grievance")
);
const Amendment = loadable(() =>
  import(/* webpackChunkName: "Amendment" */ "pages/Amendment")
);
const CTFlexMax = loadable(() =>
  import(/* webpackChunkName: "CTFlexMax" */ "pages/CTFlexMax")
);
const CTFlex = loadable(() =>
  import(/* webpackChunkName: "CTFlex" */ "pages/CTFlex")
);
const InternationaTravelInsurancePage = loadable(() =>
  import(
    /* webpackChunkName: "InternationTravelInsurance" */ "pages/InternationTravelInsurance"
  )
);
const PrivacyPage = loadable(() =>
  import(/* webpackChunkName: "PrivacyPage" */ "pages/Privacy")
);
const McpDocumentation = loadable(() =>
  import(/* webpackChunkName: "McpDocumentation" */ "pages/McpDocumentation")
);
const AboutPage = loadable(() =>
  import(/* webpackChunkName: "AboutPage" */ "pages/About")
);
const NewAboutPage = loadable(() =>
  import(/* webpackChunkName: "New AboutPage" */ "pages/NewAbout")
);

const RestRefreshPage = loadable(()=> 
  import(/* webpackChunkName: "RestRefreshPage" */ "pages/RestRefresh"))

const Blocked = loadable(() =>
  import(/* webpackChunkName: "Blocked" */ "pages/Blocked")
);
const LockDownRefunds = loadable(() =>
  import(/* webpackChunkName: "LockDownRefunds" */ "pages/LockDownRefunds")
);
const NPSFeedback = loadable(() =>
  import(/* webpackChunkName: "NPSFeedback" */ "pages/NPSFeedback")
);
const CTAdvantage = loadable(() =>
  import(/* webpackChunkName: "CTAdvantage" */ "pages/CTAdvantage")
);
const GoodHealth = loadable(() =>
  import(/* webpackChunkName: "CTAdvantage" */ "pages/GoodHealth")
);
// import BentoDemoPage from 'pages/BentoDemo'

const CtWalletTnC = loadable(() =>
  import(/* webpackChunkName: "CtWalletTnC" */ "pages/CtWalletTnC")
);

const ErrorPage = loadable(() =>
  import(/* webpackChunkName: "ErrorPage" */ "pages/ErrorPage")
);
const MediCancel = loadable(() =>
  import(/* webpackChunkName: "MediCancel" */ "pages/MediCancel")
);
const LiveChatComponent = loadable(() =>
  import(/* webPackChunkName: "LiveChatComponent" */ "pages/LiveChatComponent")
);
const ErrorComponent = loadable(() =>
  import(/* webPackChunkName: "ErrorComponent" */ "pages/ErrorComponent")
);
const CorporateInfo = loadable(() =>
  import(/* webPackChunkName: "ErrorComponent" */ "pages/CorporateInfo")
);
const Careers = loadable(() =>
  import(/* webPackChunkName: "Careers" */ "pages/Careers")
);
const AnnualReturns = loadable(() =>
  import(/* webPackChunkName: "ErrorComponent" */ "pages/CorporateInfo/AnnualReturns")
);
const DirectorsInformation = loadable(() =>
  import(/* webPackChunkName: "ErrorComponent" */ "pages/CorporateInfo/DirectorsInformation")
);
const hostName = window.location.hostname;
const path = window.location.pathname.split("/");
const dynamicPath = path.pop();
function getComponentForHost(host_name) {
  if (
    host_name === "www.cleartrip.ae" ||
    host_name === "cleartrip.ae" ||
    host_name === "qa2.cleartrip.ae"
  ) {
    return TravelSafeAE;
  } else if (
    host_name === "www.cleartrip.sa" ||
    host_name === "cleartrip.sa" ||
    host_name === "qa2.cleartrip.sa" ||
    host_name === "www.flyin.com" ||
    host_name === "flyin.com" ||
    host_name === "qa2.flyin.com"
  ) {
    return TravelSafeSAandFlyin;
  }

  return TravelSafe;
}
function getContactComponentForHost(host_name) {
  if (
    [
      "kw.cleartrip.com",
      "bh.cleartrip.com",
      "om.cleartrip.com",
      "qa.cleartrip.com",
      "www.cleartrip.ae",
      "www.cleartrip.sa",
      "www.cleartrip.me",
      "me.cleartrip.com",
      "qa2qa.cleartrip.com",
      "qa2kw.cleartrip.com",
      "qa2me.cleartrip.com",
      "qa2bh.cleartrip.com",
      "qa2om.cleartrip.com",
      "qa2new.cleartrip.ae",
      "qa2new.cleartrip.sa",
      "localhost"
    ].includes(host_name)
  )
    return ContactPageME;
  else return ContactPageME;
}
function getFlexiflyComponentForHost() {
  return FlexiflyMobilePage;
}
function getEzCancelComponentForHost() {
  return EzCancelMobilePage;
}
function getCfwComponentForHost() {
  let mobile = isMobile();
  if (mobile) {
    return CleartripForWorkMobile;
  }

  return CleartripForWork;
}

// function getBBDPage() {
//   let mobile = isMobile()
//   if (mobile) {
//     return BBDMobile
//   }

//   return BBDDekstop
// }
export default [
  {
    path: `/pages/corporate-information`,
    component: CorporateInfo,
    exact: true
    },
    {
      path: `/pages/annual-returns`,
      component: AnnualReturns,
      exact: true
      },
      {
        path: `/pages/directors-information`,
        component: DirectorsInformation,
        exact: true
        },
  {
    path: `/careers`,
    component: Careers,
    exact: true
    },
  {
    path: "/restricted",
    component: Home,
    exact: true
  },
  {
    path: "/travelsafe",
    component: getComponentForHost(hostName),
    exact: true
  },
  {
    path: "/travelsafe/flipkart",
    component: getComponentForHost(hostName),
    exact: true
  },
  {
    path: "/travelsafe/adani",
    component: TravelSafeAdani,
    exact: true
  },
  {
    path: "/travelsafe/ae",
    component: TravelSafeAE,
    exact: true
  },
  {
    path: "/travelsafe/sa",
    component: TravelSafeSAandFlyin,
    exact: true
  },
  {
    path: [
      "/ezcancel/free-flight-cancellation",
      "/lp/ezcancel/free-flight-cancellation"
    ],
    component: getEzCancelComponentForHost(),
    exact: true
  },
  {
    path: ["/lp/ct-flexmax"],
    component: CTFlexMax,
    exact: true
  },
  {
    path: [
      "/ezcancel/free-flight-cancellation-old",
      "/lp/ezcancel/free-flight-cancellation-old"
    ],
    component: EzCancelPage,
    exact: true
  },
  {
    path: "/travelsafe/gonuclei",
    component: TravelSafeGonuclei,
    exact: true
  },
  {
    path: ["/lp/flexifly", "/flexifly", "/lp/ct-flex"],
    component: getFlexiflyComponentForHost(hostName),
    exact: true
  },
  {
    path: ["/lp/cfnr", "/cfnr", "/lp/ct-cfnr"],
    component: Cfnr,
    exact: true
  },
  {
    path: ["/lp/cleartripforwork", "/cleartripforwork"],
    component: getCfwComponentForHost(),
    exact: true
  },
  {
    path: "/lp/giftcards",
    component: () => <BBDDekstop transformApiPath={() => "/pages/giftcards"} />,
    exact: true
  },
  {
    path: "/pages/giftcards",
    component: GiftCard,
    exact: true
  },
  {
    path: "/lp/payback",
    component: Payback,
    exact: true
  },
  {
    path: "/lp/flightoffer",
    component: FlightOffer,
    exact: true
  },
  {
    path: "/lp/coronahelp",
    component: CoronaHelp,
    exact: true
  },
  {
    path: "/lp/creditshell",
    component: Creditshell,
    exact: true
  },
  {
    path: "/lp/amendment",
    component: Amendment,
    exact: true
  },
  {
    path: "/lp/coronahotelhelp",
    component: CoronaHotelHelp,
    exact: true
  },
  {
    path: "/lp/expressway-plus",
    component: Expressway,
    exact: true
  },
  {
    path: "/lp/wallet",
    component: Wallet,
    exact: true
  },
  {
    path: "/lp/packages",
    component: CleartripPackages,
    exact: true,
  },
  {
    path: "/lp/ct-packages",
    component: Packages,
    exact: true,
  },
  {
    path: "/lp/smiles-faq",
    component: SmilesFaq,
    exact: true,
  },
  {
    path: "/lp/mcp_documentation",
    component: McpDocumentation,
    exact: true,
  },
  {
    path: "/contact",
    component: getContactComponentForHost(hostName),
    exact: true
  },
  {
    path: [
      "/privacy-policy",
      "/pages/privacy-policy",
      "/privacy-policy-me",
      "/privacy"
    ],
    component: PrivacyPage,
    exact: true
  },
  {
    path: "/about",
    component: AboutPage,
    exact: true
  },
  {
    path: "/flyct/about",
    component: NewAboutPage,
    exact: true
  },
  {
    path: "/pages/blocked",
    component: Blocked,
    exact: true
  },
  {
    path: "/pages/system-error",
    component: ErrorPage,
    exact: true
  },
  {
    path: "/lp/restrefresh",
    component: RestRefreshPage,
    exact: true
  },
  {
    path: "/travelsafe/flyin",
    component: TravelSafeSAandFlyin,
    exact: true
  },
  {
    path: "/pages/nps",
    component: NPSFeedback,
    exact: true
  },
  {
    path: ["/lp/supercoin", "/supercoin"],
    component: Supercoin,
    exact: true
  },
  {
    path: "/pages/lockdown-refund",
    component: LockDownRefunds,
    exact: true
  },
  {
    path: "/terms-of-service",
    component: TermsOfService,
    exact: true
  },
  {
    path: "/terms",
    component: TermsOfService,
    exact: true
  },
  {
    path: "/grievance",
    component: Grievance,
    exact: true,
  },
  {
    path: "/lp/ct-advantage",
    component: CTAdvantage,
    exact: true
  },
  {
    path: "/lp/good-health-reliance",
    component: GoodHealth,
    exact: true
  },
  {
    path: "/lp/intl-travelins-reliance",
    component: InternationaTravelInsurancePage,
    exact: true
  },
  {
    path: "/terms/ct-wallet",
    component: CtWalletTnC,
    exact: true
  },
  {
    path: `/pages/${dynamicPath}`, // the route will be always last
    component: BBDDekstop,
    exact: true
  },
  {
    path: ["/lp/medi-cancel"],
    component: MediCancel,
    exact: true
  },
  {
    path: `/pages/lc/:liveChatId`,
    component: LiveChatComponent,
    exact: true
  },
  {
    path: `/pages/error/:errorType`,
    component: ErrorComponent,
    exact: true
  },
];
